export class UsuarioSector {
    constructor(
        public idHospital: number,
        public idIsla: string,
        public idSector: string,
        public cuil: string,
        public estado: number, //1:activo / 0:inactivo
        public sync_id?: number
    ){}
}